import {ForwardToInbox} from "@mui/icons-material";
import {LabeledSection, LabeledValue} from "../../../components/Layout/Page";
import React from "react";
import {usePlSentRegisterMutation} from "../../../app/api/api";
import {useSnackbar} from "notistack";
import {useTranslation} from "react-i18next";
import {PlSentStatus} from "../../../app/api/model/device";
import PlSentStatusChip from "../../../components/PLSENTStatus";
import {PermissionLevel} from "../../../app/api/model/user";

type PLSentSectionProps = {
    plSentId?: string;
    plSentStatus: PlSentStatus;
    leoId: string | undefined;
};

const PLSentSection = ({plSentId, plSentStatus, leoId}: PLSentSectionProps) => {
    const {t} = useTranslation();
    const {enqueueSnackbar} = useSnackbar();
    const [registerPlSent] = usePlSentRegisterMutation();
    const sendPLRegistration = () => {
        if (typeof leoId === "string") {
            registerPlSent({
                leoId,
            })
                .unwrap()
                .then(() => {
                    enqueueSnackbar(t("plSent_registrationSuccesfull"), {variant: "success"});
                });
        }
    };

    return (
        <LabeledSection
            title={t("title_plSent")}
            buttons={
                !plSentId && plSentStatus !== PlSentStatus.PENDING
                    ? [
                          {
                              key: "register",
                              tooltip: plSentId ? "tooltip_plSentMissingLeoId" : "tooltip_plSentActionRegister",
                              disabled: !leoId || plSentStatus === PlSentStatus.REGISTERED,
                              minRequiredPermissionToSee: PermissionLevel.MANAGER,
                              callback: sendPLRegistration,
                              icon: <ForwardToInbox />,
                          },
                      ]
                    : []
            }
        >
            <LabeledValue
                label={t("generic_plSentId")}
                content={plSentId || <PlSentStatusChip status={plSentStatus} />}
                isCopyAlwaysVisible={true}
            />
        </LabeledSection>
    );
};

export default PLSentSection;
